import React, {PropsWithChildren} from 'react'

import {Box} from '../Box/Box'

export function PageLayout({children}: PropsWithChildren<unknown>) {
  return <Box sx={{padding: 3}}>{children}</Box>
}
